import is from '@sindresorhus/is';
import { matchPath } from 'react-router';

import type { UiActionBlock } from '../data-contract/chat';

export type AgentUiPathResolver = (block: UiActionBlock) => string | undefined;

type AgentUiLocation = { readonly pathname: string; readonly search: string };

export const autoRunPath = (
    path: string | undefined,
    { pathname, search }: AgentUiLocation,
    origins: readonly string[],
): string | null => {
    const isAtOrigin = origins.some((origin) => !is.null(matchPath(origin, pathname)));

    return !isAtOrigin || is.undefined(path) || path === `${pathname}${search}` ? null : path;
};
